import styled, { css } from 'styled-components';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, themeGet } from 'modules/tetrisTheme';
import { getChipAppearance } from './getChipAppearance';
import { getChipActionPadding, getContainerSize, getContentContainerPadding, getIconSize, getLoaderSize, } from './utils';
export const PrimaryLabel = styled(Typography) ``;
export const SecondaryLabel = styled(Typography) ``;
const chipPart = css `
  position: relative;
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0;
  margin: 0;
  background: transparent;
  border: solid ${pxToRem(1)};
  color: ${themeGet('color.100')};
  outline: none;

  &:is(button) {
    cursor: pointer;
  }

  ${interactiveTransition};
`;
export const ChipAction = styled.button `
  ${chipPart};
  margin-left: auto;
`;
export const ChipContent = styled.button `
  ${chipPart};
  width: 100%;
  gap: ${pxToRem(4)};
  overflow: hidden;
`;
export const ChipContainer = styled.div `
  --chip-border-radius: ${themeGet('borderRadius.sm')};

  display: flex;
  align-items: center;
  max-width: 100%;

  ${({ $size }) => getContainerSize($size)};

  ${ChipContent}, ${ChipAction} {
    ${({ $appearance, $variant }) => getChipAppearance($appearance, $variant)};
  }

  ${ChipContent} {
    ${({ $wrap }) => !$wrap && `white-space: nowrap;`};
    ${({ $size }) => getContentContainerPadding($size)};
  }

  ${ChipAction} {
    ${({ $size }) => getChipActionPadding($size)};
  }

  ${({ $size }) => getLoaderSize($size)};

  & > *:first-child {
    border-top-left-radius: var(--chip-border-radius);
    border-bottom-left-radius: var(--chip-border-radius);

    &:not(:only-child) {
      border-right: none;
    }
  }

  & > *:last-child {
    border-top-right-radius: var(--chip-border-radius);
    border-bottom-right-radius: var(--chip-border-radius);

    &:not(:only-child) {
      border-left: none;
    }
  }

  [data-icon='falcon'] {
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1 / 1;
    ${({ $size }) => getIconSize($size)};
  }
`;
